import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Clock, Siren, PackageCheck } from "lucide-react";
import { api } from "../lib/api";
import { Panel } from "../lib/ui";

const STATES = [
  { key: "late", label: "Terlambat", icon: Siren, cls: "bg-red-50 text-red-700 border-red-200" },
  { key: "urgent", label: "Segera (<3 jam)", icon: AlertTriangle, cls: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "today", label: "Wajib hari ini", icon: Clock, cls: "bg-amber-50 text-amber-700 border-amber-200" },
];

export const PendingShipmentsCard = () => {
  const [sum, setSum] = useState(null);
  useEffect(() => {
    api.get("/desty/pending-shipments").then((r) => setSum(r.data.summary)).catch(() => setSum(null));
  }, []);
  if (!sum || sum.total === 0) return null;
  return (
    <Panel className="p-4 mb-6" data-testid="pending-shipments-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-cocoa font-heading font-semibold">
          <PackageCheck className="w-5 h-5" />
          Paket Belum Dikirim
          {sum.action_needed > 0 && (
            <span className="ml-1 px-2 py-0.5 rounded-full bg-red-600 text-white text-xs" data-testid="pending-action-badge">{sum.action_needed} perlu tindakan</span>
          )}
        </div>
        <Link to="/ventedaily/pending-shipments" className="text-sm text-cocoa underline" data-testid="pending-see-all">Lihat semua ({sum.total})</Link>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {STATES.map((s) => {
          const Icon = s.icon;
          return (
            <Link key={s.key} to="/ventedaily/pending-shipments" className={`rounded-xl border p-3 flex items-center gap-3 ${s.cls}`} data-testid={`pending-state-${s.key}`}>
              <Icon className="w-5 h-5 shrink-0" />
              <div>
                <div className="text-2xl font-bold leading-none">{sum[s.key] || 0}</div>
                <div className="text-xs mt-1">{s.label}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </Panel>
  );
};
